import React from 'react'
import KitchenConfigSection from './KitchenConfigSection'

interface Props {
  locationId: number
  kitchenConfigurationOptions: Record<string, { rows: number, columns: number }>
  onDirtyChange?: (dirty: boolean) => void
}

const Status = ({ locationId, kitchenConfigurationOptions, onDirtyChange }: Props) => (
  <div className="py-3">
    <KitchenConfigSection
      locationId={locationId}
      kitchenConfigurationOptions={kitchenConfigurationOptions}
      onDirtyChange={onDirtyChange}
    />
  </div>
)

export default Status
